import { useState } from 'react';

// import Box from '@mui/material/Box';
// import IconButton from '@mui/material/IconButton';
// import Input from '@mui/material/Input';
// import FilledInput from '@mui/material/FilledInput';
import OutlinedInput from '@mui/material/OutlinedInput';
// import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
// import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
// import TextField from '@mui/material/TextField';

import './inputItemsPerPage.css';

export default function InputItemsPerPage(props) {

	// console.log( 'InputItemsPerPage props:: ', props );

  const [values, setValues] = useState({
    itemsPerPage: props.itemsPerPage * 1
  });

	const getClass = (classes) => {
		classes = classes || ''
		let visible = typeof props.visible === 'boolean' ? props.visible : true;
		if ( ! visible ) {
			classes += ' hidden';
		}
		return 'items-per-page-form full-width '+classes
	}

  const onBlur = (event) => {
		props.afterEdit(values);
	}
	
  const onChange = (prop) => (event) => {
		let _value = event.target.value.replace(/[^0-9]/g, '');
		if ( _value * 1 < 101 ) {
			setValues({ ...values, [prop]: _value });
		}
  };
	
	return (
    <div className={getClass()} >
			<FormControl sx={{ m: 1, width: '25ch' }} variant="outlined">
				<OutlinedInput
					id="outlined-adornment-items-per-page"
					value={values.itemsPerPage}
					onChange={onChange('itemsPerPage')}
					onBlur={onBlur}
					startAdornment={<InputAdornment position="start">Items per page</InputAdornment>}
					inputProps={{inputMode:'numeric',pattern: '[0-9]*'}} 
				/>
			</FormControl>	
    </div>
  );
	
}